import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const search = createAsyncThunk("search", async (query) => {
    const response = await axiosInstance.get(`/search/?q=${query}`, {});
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const searchSuggested = createAsyncThunk("searchSuggested", async (query) => {
    const response = await axiosInstance.get(`/search/posts/suggestions/?q=${query}`, {});
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const searchOnlyPosts = createAsyncThunk("searchOnlyPosts", async ({ query, page = 1 }) => {
    try {
        const response = await axiosInstance.get(`/search/posts/?page=${page}&q=${query}`, {});
        // "http://chaachingg.com/api/search/posts/?page=2&q=cars",
        const result = response.data;
        return { ...result, page };
    } catch (error) {
        return error;
    }
});

export const searchOnlyUsers = createAsyncThunk("searchOnlyUsers", async ({ query, page = 1 }) => {
    try {
        const response = await axiosInstance.get(`/search/users/?page=${page}&q=${query}`, {});
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const clickSearchedUser = createAsyncThunk("clickSearchedUser", async (query) => {
    try {
        const response = await axiosInstance.get(`/search/users/?q=${query}`, {});
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const searchTrendingUsers = createAsyncThunk("searchTrendingUsers", async ({ page = 1 }) => {
    try {
        const response = await axiosInstance.get(`/search/trending-users/?page=${page}`, {});
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const searchTrendingPosts = createAsyncThunk("searchTrendingPosts", async ({ page = 1 }) => {
    try {
        const response = await axiosInstance.get(`/search/trending-posts/?page=${page}`, {});
        const result = response.data;
        return { result, page };
    } catch (error) {
        return error;
    }
});
export const searchHashtags = createAsyncThunk("searchHashtags", async ({ query, page = 1 }) => {
    const response = await axiosInstance.get(`/search/hashtags/?q=${query}&page=${page}`, {});
    try {
        const result = response.data;
        return result;
    } catch (error) {

        return error;
    }
});

export const groupSearch = createAsyncThunk("groupSearch", async (query) => {
    const response = await axiosInstance.get(`/group/groups/search/?q=${query}`, {});
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const userSearch = createAsyncThunk("userSearch", async (query) => {
    const response = await axiosInstance.get(`/group/groups/search/?q=${query}`, {});
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const recentSearch = createAsyncThunk("recentSearch", async (query) => {
    const response = await axiosInstance.get(`/search/recent/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const deleteAllRecentSearch = createAsyncThunk("deleteAllRecentSearch", async () => {
    const response = await axiosInstance.delete(`/search/recent/clear/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const deleteIndividualRecentSearch = createAsyncThunk("deleteIndividualRecentSearch", async ({ searchId }) => {
    const response = await axiosInstance.delete(`/search/recent/${searchId}/delete/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const SearchSlice = createSlice({
    name: "SearchSlice",
    initialState: {
        SearchResult: [],
        SuggestedSearchResult: [],
        postsSearchResult: [],
        trendingPostSearchResult: {},
        groupSearchResult: [],
        hashtagSearchResult: [],
        recentSearch: [],
        trendingUsers: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // HomepageVideo action promises
        builder.addCase(search.pending, (state) => {
            state.loading = true;
            state.SearchResult = [];
        });
        builder.addCase(search.fulfilled, (state, action) => {
            state.SearchResult = action.payload;
            state.loading = false;
        });
        builder.addCase(search.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        ///suggested search result
        builder.addCase(searchSuggested.pending, (state) => {
            state.loading = true;
            state.SuggestedSearchResult = [];
        });
        builder.addCase(searchSuggested.fulfilled, (state, action) => {
            state.SuggestedSearchResult = action.payload;
            state.loading = false;
        });
        builder.addCase(searchSuggested.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        /// search only posts
        builder.addCase(searchOnlyPosts.pending, (state) => {
            state.loading = true;
            // Don't clear results if loading more pages
        });
        builder.addCase(searchOnlyPosts.fulfilled, (state, action) => {
            const { page, posts } = action.payload;

            if (page === 1) {
                // First page - replace the array
                state.postsSearchResult = action.payload;
            } else {
                // Subsequent pages - append to existing results
                const existingResults = state.postsSearchResult?.posts?.results || [];
                state.postsSearchResult = {
                    ...action.payload,
                    posts: {
                        ...action.payload.posts,
                        results: [...existingResults, ...(posts?.results || [])]
                    }
                };
            }
            state.loading = false;
        });
        builder.addCase(searchOnlyPosts.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


        //user search user list
        builder.addCase(searchOnlyUsers.pending, (state) => {
            state.loading = true;
            state.SearchResult = [];
        });
        builder.addCase(searchOnlyUsers.fulfilled, (state, action) => {
            state.SearchResult = action.payload;
            state.loading = false;
        });
        builder.addCase(searchOnlyUsers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //trending user list
        builder.addCase(searchTrendingUsers.pending, (state) => {
            state.loading = true;
            state.trendingUsers = [];
        });
        builder.addCase(searchTrendingUsers.fulfilled, (state, action) => {
            state.trendingUsers = action.payload?.results;
            state.loading = false;
        });
        builder.addCase(searchTrendingUsers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // search hashtags
        builder.addCase(searchHashtags.pending, (state, action) => {
            state.loading = true;
            if (action.meta.arg.page === 1) {
                state.hashtagSearchResult = [];
            }
        });
        builder.addCase(searchHashtags.fulfilled, (state, action) => {
            state.hashtagSearchResult = {
                ...action.payload,
                results: [
                    ...(state.hashtagSearchResult?.results || []),
                    ...(action.payload?.results || [])
                ]
            };
            state.loading = false;
        });

        builder.addCase(searchHashtags.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        /// trending posts
        builder.addCase(searchTrendingPosts.pending, (state, action) => {
            state.loading = true;
            if (action.meta.arg.page === 1) {
                state.trendingPostSearchResult = {};
            }
        }
        );
        builder.addCase(searchTrendingPosts.fulfilled, (state, action) => {
            // Subsequent pages - append to existing results
            const { page, result } = action.payload;
            const existingResults = state.trendingPostSearchResult?.results || [];
            state.trendingPostSearchResult = {
                ...result,
                results: [...existingResults, ...(result?.results || [])]
            };
            state.loading = false;
        })

        builder.addCase(searchTrendingPosts.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


        builder.addCase(groupSearch.pending, (state) => {
            state.loading = true;
            state.SearchResult = [];
        });
        builder.addCase(groupSearch.fulfilled, (state, action) => {
            state.groupSearchResult = action.payload;
            state.loading = false;
        });
        builder.addCase(groupSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(userSearch.pending, (state) => {
            state.loading = true;
            state.SearchResult = [];
        });
        builder.addCase(userSearch.fulfilled, (state, action) => {
            state.SearchResult = action.payload;
            state.loading = false;
        });
        builder.addCase(userSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(recentSearch.pending, (state) => {
            state.loading = true;
            state.recentSearch = [];
        });
        builder.addCase(recentSearch.fulfilled, (state, action) => {
            state.recentSearch = action.payload;
            state.loading = false;
        });
        builder.addCase(recentSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(deleteAllRecentSearch.pending, (state) => {
            state.loading = true;
            state.recentSearch = [];
        });
        builder.addCase(deleteAllRecentSearch.fulfilled, (state) => {
            state.recentSearch = [];
            state.loading = false;
        });
        builder.addCase(deleteAllRecentSearch.rejected, (state, action) => {
            state.loading = false;
            state.recentSearch = [];
            state.error = action.payload;
        });

        builder.addCase(deleteIndividualRecentSearch.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteIndividualRecentSearch.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(deleteIndividualRecentSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default SearchSlice.reducer;
